import { NgModule }              from '@angular/core';
import { EffectsModule }         from '@ngrx/effects';
import { StoreModule }           from '@ngrx/store';
import { ListOperationsEffects } from '@shared/list-operations/store/list-operations.effects';
import { listOperationsStore }   from '@shared/list-operations/store/list-operations.store';


@NgModule( {
	declarations: [],
	imports: [
		StoreModule.forFeature( listOperationsStore.storeId, listOperationsStore.reducers ),
		EffectsModule.forFeature( [ ListOperationsEffects ] )
	]
} )
export class ListOperationsStoreModule {}
